function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  className: "nc-icon-wrapper",
  fill: "#fff"
}, React.createElement("path", {
  fill: "#fff",
  d: "M15,3h-4c-0.6,0-1,0.4-1,1s0.4,1,1,1h4c0.6,0,1-0.4,1-1S15.6,3,15,3z"
}), React.createElement("path", {
  fill: "#fff",
  d: "M5,1C3.7,1,2.6,1.9,2.2,3C2.1,3,2.1,3,2,3H1C0.4,3,0,3.4,0,4s0.4,1,1,1h1c0.1,0,0.1,0,0.2,0 C2.6,6.1,3.7,7,5,7c1.7,0,3-1.3,3-3S6.7,1,5,1z"
}), React.createElement("path", {
  "data-color": "color-2",
  d: "M1,13h4c0.6,0,1-0.4,1-1s-0.4-1-1-1H1c-0.6,0-1,0.4-1,1S0.4,13,1,13z"
}), React.createElement("path", {
  "data-color": "color-2",
  d: "M15,11h-1c-0.1,0-0.1,0-0.2,0c-0.4-1.2-1.5-2-2.8-2c-1.7,0-3,1.3-3,3s1.3,3,3,3 c1.3,0,2.4-0.9,2.8-2c0.1,0,0.1,0,0.2,0h1c0.6,0,1-0.4,1-1S15.6,11,15,11z"
}));

var SvgSetupPreferences = function SvgSetupPreferences(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSetupPreferences, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/setup-preferences.4a53538c.svg";
export { ForwardRef as ReactComponent };